import {
  getNameDescriptionTableColumn,
} from '@/utils/common/tableColumn'
import { numerify } from '@/filters'
import Status from '@/components/Status'
import i18n from '@/locales'

export default {
  created () {
    this.columns = [
      getNameDescriptionTableColumn({
        onManager: this.onManager,
        hideField: true,
        slotCallback: row => {
          return (
            <side-page-trigger onTrigger={() => this.handleOpenSidepage(row)}>{ row.name }</side-page-trigger>
          )
        },
      }),
      {
        field: 'currency',
        title: i18n.t('scope.text_420'),
        minWidth: 70,
      },
      {
        field: 'domain_src',
        title: i18n.t('scope.text_421'),
        minWidth: 100,
        formatter: ({ row }) => {
          if (row.domain_src === 'local') return i18n.t('scope.text_422')
          return i18n.t('scope.text_423')
        },
      },
      {
        field: 'credit',
        title: i18n.t('scope.text_424'),
        minWidth: 70,
        formatter: ({ row }) => {
          return row.credit
        },
      },
      {
        title: i18n.t('scope.text_426'),
        field: 'status',
        minWidth: 120,
        slots: {
          default: ({ row }, h) => {
            let status = 'init'
            if (row.is_overdue) {
              status = 'overdue'
            }
            if (row.is_arrears) {
              status = 'arrears'
            }
            return [
              <div class='text-truncate'>
                <Status status={ status } statusModule="bill" />
              </div>,
            ]
          },
        },
      },
      {
        title: i18n.t('scope.text_429'),
        field: 'balance',
        minWidth: 70,
        formatter: ({ row }) => {
          const sign = row.currency === 'USD' ? '$' : '￥'
          return sign + numerify(row.balance, '0,0.00')
        },
      },
      {
        title: i18n.t('op_1'),
        field: 'due',
        minWidth: 70,
        formatter: ({ row }) => {
          const sign = row.currency === 'USD' ? '$' : '￥'
          return sign + numerify(row.due, '0,0.00')
        },
      },
      {
        title: i18n.t('op_2'),
        field: 'pending_due',
        minWidth: 70,
        formatter: ({ row }) => {
          const sign = row.currency === 'USD' ? '$' : '￥'
          return sign + numerify(row.pending_due, '0,0.00')
        },
      },
      {
        title: i18n.t('op_3'),
        field: 'onpay',
        minWidth: 70,
        formatter: ({ row }) => {
          const sign = row.currency === 'USD' ? '$' : '￥'
          return sign + numerify(row.onpay, '0,0.00')
        },
      },
      {
        title: i18n.t('scope.text_430'),
        field: 'net',
        minWidth: 70,
        formatter: ({ row }) => {
          const sign = row.currency === 'USD' ? '$' : '￥'
          return sign + numerify(row.net, '0,0.00')
        },
      },
    ]
  },
}
